import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import { RotatingLines } from "react-loader-spinner";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { useAuth } from "../../context/Auth";

const RegisterChurch = () => {
  const {requestWithAuth} = useAuth()
  const [registrationData, setRegistrationData] = useState({
    sms_sender_id: "ADOM CHAPEL",
    sms_bundle: 100
  });
    const [submitting, setSubmitting] = useState(false);
    const [checkingAvailability, setCheckingAvailability] = useState(false);
    const [available, setAvailable] = useState(false)
    const [passwordVisibility, setPasswordVisibility] = useState(false)


    
  const checkAvailability = async () => {
    setCheckingAvailability(true)
    try {
      const responseData = await requestWithAuth(`/accounts/${registrationData?.username}/availability`, 'GET');
      setAvailable(responseData)
    } catch (error) {
      
    }finally{
      setCheckingAvailability(false)
    }
  }

  const handleChange = (e) => {
    setRegistrationData({
      ...registrationData,
      [e.target.name]: e.target.value,
    });
  };

  const submitForm = async (e) => {
    e.preventDefault();
    setSubmitting(true)
    try {
      const formData = new FormData();
      Object.keys(registrationData).forEach((key) => {
        formData.append(key, registrationData[key]);
      })
      const responseData = await requestWithAuth('/superadmin/churches/', 'POST', formData, {
        'Content-Type': 'multipart/form-data'
      })
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Church registered successfully",
      }).then(() => {
        window.location.href = "/super/churches"
      });
    } catch (error) {
      if(error.response.data){
        toast.error(error.response.data.message)
        if(error.response.status === 400){
          for( const property in error.response.data.errors){
            toast.error(`${property} error: ${error.response.data.errors[property]}`)
          }
        }else{
          toast.error("Internal server error")
        }
      }else{
        toast.error("something went wrong!")
      }
    }finally{
      setSubmitting(false)
    }
  }

  useEffect(()=>{
    if(registrationData?.username){
      checkAvailability()
    }
  }, [registrationData?.username])
  return (
    <div>
      <Header title="Register Church" />
      <form onSubmit={e=>submitForm(e)} className="border border-gray-500">
        <div className="bg-primary text-secondary px-5 py-2">
          CHURCH DETAILS
        </div>
        <div className="grid lg:grid-cols-3 gap-5 p-5">
          <div className="flex flex-col">
            <label htmlFor="">Church Logo</label>
            <input
              type="file"
              onChange={(e) => {
                setRegistrationData({
                  ...registrationData, ['church_logo']: e.target.files[0]
                })
              }}
              name="church_logo"
              id="church_logo"
              className="border border-gray-500 px-3 py-2 outline-none rounded"
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="">
              Church Name
              <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              onChange={(e) => handleChange(e)}
              name="church_name"
              id="church_name"
              className="border border-gray-500 px-3 py-2 outline-none rounded"
            />
          </div>
          
          <div className="flex flex-col">
            <label htmlFor="">
              Church Branch
              <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              onChange={(e) => handleChange(e)}
              name="church_branch"
              id="church_branch"
              className="border border-gray-500 px-3 py-2 outline-none rounded"
            />
            <small>This can be the congregation name, parish name etc</small>
          </div>

          <div className="flex flex-col">
            <label htmlFor="">Phone Number</label>
            <input
              type="text"
              onChange={(e) => handleChange(e)}
              name="church_phone_number"
              id="church_phone_number"
              className="border border-gray-500 px-3 py-2 outline-none rounded"
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="">
              Email
              <span className="text-danger">*</span>
            </label>
            <input
              type="email"
              name="church_email"
              id="church_email"
              onChange={(e) => handleChange(e)}
              className="border border-gray-500 px-3 py-2 outline-none rounded"
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="">Location *</label>
            <input
              type="text"
              onChange={(e) => handleChange(e)}
              name="church_location"
              id="church_location"
              required
              className="border border-gray-500 px-3 py-2 outline-none rounded"
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="">SMS Sender ID</label>
            <input
              type="text"
              onChange={(e) => handleChange(e)}
              name="sms_sender_id"
              id="sms_sender_id"
              value={registrationData.sms_sender_id}
              className="border border-gray-500 px-3 py-2 outline-none rounded"
            />
            <small>Default sender ID for SMS messages</small>
          </div>

          <div className="flex flex-col">
            <label htmlFor="">SMS Bundle</label>
            <input
              type="number"
              onChange={(e) => handleChange(e)}
              name="sms_bundle"
              id="sms_bundle"
              value={registrationData.sms_bundle}
              min="0"
              className="border border-gray-500 px-3 py-2 outline-none rounded"
            />
            <small>Number of SMS credits allocated</small>
          </div>
        </div>
        <div className="bg-primary text-secondary px-5 py-2">
          CHURCH ADMINISTRATOR DETAILS
        </div>
        <div className="grid lg:grid-cols-3 gap-5 p-5">
          <div className="flex flex-col">
            <label htmlFor="">
              First Name
              <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              onChange={(e) => handleChange(e)}
              name="first_name"
              id="first_name"
              className="border border-gray-500 px-3 py-2 outline-none rounded"
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="">
              Last Name
              <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              onChange={(e) => handleChange(e)}
              name="last_name"
              id="last_name"
              className="border border-gray-500 px-3 py-2 outline-none rounded"
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="">
              Gender
              <span className="text-danger">*</span>
            </label>
            <div className="radio-row">
              <div className="radio-item">
                <input
                  type="radio"
                  onChange={(e) => handleChange(e)}
                  name="gender"
                  value="Male"
                />{" "}
                Male
              </div>
              <div className="radio-item">
                <input
                  type="radio"
                  onChange={(e) => handleChange(e)}
                  name="gender"
                  value="Female"
                />{" "}
                Female
              </div>
            </div>
          </div>

          <div className="flex flex-col">
            <label htmlFor="">
              Address
              <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              onChange={(e) => handleChange(e)}
              name="address"
              id="address"
              className="border border-gray-500 px-3 py-2 outline-none rounded"
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="">
              Phone Number
              <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="phone_number"
              id="phone_number"
              onChange={(e) => handleChange(e)}
              className="border border-gray-500 px-3 py-2 outline-none rounded"
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="">Email</label>
            <input
              type="email"
              onChange={(e) => handleChange(e)}
              name="email"
              id="email"
              className="border border-gray-500 px-3 py-2 outline-none rounded"
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="">Username</label>
            <input
              type="text"
              onChange={(e) => handleChange(e)}
              name="username"
              id="username"
              className="border border-gray-500 px-3 py-2 outline-none rounded"
            />
            {
                    registrationData?.username && (
                      <p>
                        {
                          checkingAvailability ? (
                            <p>Checking availability...</p>
                          ):(
                            <>
                              {
                                available ? (
                                  <p className="text-green-500 font-bold">
                                    {registrationData?.username} is available
                                  </p>
                                ):(
                                  <p className="text-red-500 font-bold">
                                    {registrationData?.username} is not available
                                  </p>
                                )
                              }
                            </>
                          )
                        }
                      </p>
                    )
                  }
          </div>

          <div className="flex flex-col">
            <label htmlFor="">Password</label>
            <input
              type={passwordVisibility ? "text":"password"}
              onChange={(e) => handleChange(e)}
              name="password"
              id="password"
              className="border border-gray-500 px-3 py-2 outline-none rounded"
            />
            <small onClick={()=>setPasswordVisibility(!passwordVisibility)} className="underline text-blue-500 cursor-pointer">
                  {
                    passwordVisibility ? "Hide password":"Show Password"
                  }
            </small>
          </div>

        
       
        </div>
        <div className="p-5 flex items-center justify-end">
            {submitting ? (
                <div className="flex gap-2 p-2 bg-gray-300 rounded">
                    <RotatingLines
                    strokeColor="black"
                    height="20"
                    width="20"
                    /> Creating Church
                </div>
            ):(
                <button className="bg-primary px-4 py-2 text-white rounded-md cursor-pointer hover:bg-primary/90">
                    Register
                </button>
            )}
        </div>
      </form>
    </div>
  );
};

export default RegisterChurch;